<template>
  <vue-tel-input-vuetify
    :value="value"
    @input="emit"
    :rules="rules"
    :label="label"
    :required="required"
    :outlined="outlined"
    :solo="solo"
    :flat="flat"
    :dense="dense"
    hide-details="auto"
    :placeholder="placeholder"
    :class="{ 'bg-white': solo }"
  ></vue-tel-input-vuetify>
</template>
<script>
export default {
  props: {
    value: {
      default: null,
      type: String
    },
    rules: {
      detault: () => {
        return [];
      },
      type: Array
    },
    label: {
      default: null,
      type: String
    },
    outlined: {
      default: false,
      type: Boolean
    },
    flat: {
      default: false,
      type: Boolean
    },
    solo: {
      default: false,
      type: Boolean
    },
    dense: {
      default: false,
      type: Boolean
    },
    placeholder: {
      default: null,
      type: String
    },
    hideDetails: {
      default: "auto",
      type: String
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    emit(evt) {
      this.$emit("input", evt.replaceAll(" ", ""));
    }
  }
};
</script>
<style lang="scss">
.country-code {
    .v-input__slot {
      border: none !important;
      min-height: 38px;
      height: 38px;
      padding-left: 3px !important;
      padding-right: 3px !important;
      margin-bottom: 0;
      .v-input__icon--append {
        margin-left: 0 !important;
        padding-left: 0 !important;
      }
      .v-input__append-inner {
        margin-left: 0 !important;
        padding-left: 0 !important;
        margin-top: 5px !important;
      }
    }
    .v-text-field__details {
      display: none;
    }
    fieldset {
      border-top: 1px solid !important;
      border-right: none !important;
      border-bottom: 1px solid !important;
      border-left: 1px solid !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      border-top-left-radius: 4px !important;
      border-bottom-left-radius: 4px !important;
    }
  }
.vue-tel-input-vuetify {
  align-items: flex-start;
  .v-input__slot {
    margin-bottom: 8px;
    min-height: 38px;
    border: none !important;
    padding: 0 0px !important;
    .v-label {
      top: 10px;
    }
    fieldset {
      border-top: 1px solid;
      border-left: none;
      border-bottom: 1px solid;
      border-right: 1px solid;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .v-text-field > .v-input__control > .v-input__slot:before {
    border: none;
    border-style: none;
  }
  .v-text-field--solo-flat {
    .v-input__slot {
      .v-label {
        top: 0px;
      }
    }
  }
  .v-text-field.v-input--is-focused > .v-input__control > .v-input__slot:after {
    border: none;
    border-style: none;
  }
}
.vue-tel-input-vuetify .v-text-field .v-select__selections .vti__flag {
  left: 15px;
}
</style>
